import React, { Component } from 'react';
import { shanehList } from '../../../settings';


export default class RugShanehs extends Component {

    render() {
        return (
            <div className={this.props.activeFilters.indexOf("shanehs") !== -1 ? "items-body" : "items-body active"}>
                <div className="d-grid">
                    {Object.keys(shanehList).map((shaneh, i) =>
                        <label className="filter-effect-input" key={shaneh + i}>
                            {shaneh}
                            <input type="checkbox" checked={this.props.selectedShanehs.indexOf(shaneh) !== -1} onChange={() => this.props.changeHandler("shanehs", shaneh)} />
                            <span className="checkmark" />
                        </label>
                    )}
                </div>
            </div>
        )
    }
}